import {api} from '../components/Base/App';

export default {
    getProperty(propertyId, embed) {
        const params = new URLSearchParams();

        embed.forEach(element => {
            params.append('embed', element);
        });

        return api({
            method: 'get',
            url: `/rest/gw/site/property/${propertyId}`,
            params: params
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/Property.js